module.exports = __webpack_public_path__ + "img/mco.a9db68cd.svg";